(() => {
  const callback = () => {
    if (!window.themeComponents.snippets.register('promo-grid')) return;

    const selectors = {
      wrapper: '.promo-grid',
      swiper: '.swiper',
      swiperButtonNext: '.swiper-button-next',
      swiperButtonPrev: '.swiper-button-prev',
    };

    const initSlider = ({ targetSection } = {}) => {
      const targetSelector = targetSection ? `#${targetSection.getAttribute('id')}` : '';
      const queryString = `${targetSelector} ${selectors.wrapper} ${selectors.swiper}`;

      const sliders = document.querySelectorAll(queryString);
      sliders.forEach((slider) => {
        new Swiper(slider, {
          slidesPerView: slider.dataset.fullWidth === 'true' ? 1.1 : 1.05,
          slidesPerGroup: 1,
          spaceBetween: 5,
          freeMode: {
            enabled: true,
            sticky: true,
          },
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: selectors.swiperButtonNext,
            prevEl: selectors.swiperButtonPrev,
          },
          breakpoints: {
            769: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
          },
        });
      });
    };
    initSlider();

    document.addEventListener('shopify:section:load', (event) => initSlider({ targetSection: event.target }));
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
